// src/App.tsx
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRoutes } from 'react-router-dom';

import { routes } from '@/routes';
import { initializeAuth } from '@/store/slices/authSlice';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  const element = useRoutes(routes);
  return element;
}

export default App;